// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../../../../node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/lib/index.js??ref--2-2!./style.postcss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./containers/Group/UnitReportHFv4/StudentReportView/ReportStudentCard/style.postcss
// module id = 1918
// module chunks = 0